import { useTranslation } from '@rhino-project/core/i18n';
import { useWatch } from 'react-hook-form';

import { useEffect, useMemo } from 'react';
import { useModelFiltersContext } from '@rhino-project/core/hooks';
import { FieldSelect } from '../../../FieldSelect';
import { ListBoxItem } from '@heroui/react';
import { filterPillText, useModelFilterField } from '../../../form';

const humanizeEnumValue = (value: string) =>
  value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export const ModelFilterEnum = ({
  path,
  ...props
}: {
  path: string;
  [key: string]: unknown;
}) => {
  const { t } = useTranslation();
  const { attribute, operator, operatorPath, ...rest } =
    useModelFilterField(path);

  const options = useMemo(
    () =>
      attribute?.enum?.map((value: string) => {
        const label = attribute.enumLabels?.[value] || humanizeEnumValue(value);
        return (
          <ListBoxItem key={value} id={value} textValue={label}>
            {label}
          </ListBoxItem>
        );
      }) || [],
    [attribute]
  );

  const watch = useWatch({ name: operatorPath });

  const { setPill } = useModelFiltersContext();

  useEffect(() => {
    if (watch !== undefined && watch !== '')
      setPill(
        operatorPath,
        filterPillText(
          attribute,
          operator,
          typeof watch === 'string'
            ? attribute.enumLabels?.[watch] || humanizeEnumValue(watch)
            : watch
        )
      );
  }, [attribute, operator, operatorPath, setPill, watch]);

  return (
    <FieldSelect
      path={operatorPath}
      placeholder={t('rhino.frontend.messages.select_a_value', {
        value1: attribute.readableName.toLowerCase()
      })}
      {...(rest as Record<string, unknown>)}
      {...props}
    >
      {options}
    </FieldSelect>
  );
};
